
import { Component, Prop, Mixins } from 'vue-property-decorator';
import {
  Dialog,
  Form,
  FormItem,
  Select,
  Option,
  Input,
  InputNumber,
  Button,
  Radio,
  RadioGroup,
} from 'element-ui';
import { IResource } from '@/types/course.d';
import api from '@/api/course';
import FormMixin from './formMxin';
import pageMixin from '../../../../../../mixins/pageMixin';

@Component({
  components: {
    Dialog,
    Form,
    FormItem,
    Select,
    Option,
    Input,
    InputNumber,
    Button,
    Radio,
    RadioGroup,
  },
})
export default class ManageBusModal extends Mixins(FormMixin, pageMixin) {
  @Prop({
    required: true,
    default: false,
  }) visible!: boolean;

  @Prop({
    required: true,
    default: false,
  }) title!: string;

  @Prop({
    required: false,
  }) oldForm!: any;

  @Prop({
    required: false,
  }) videoForm!: string;

  private types: { value: number, label: string }[] = [{
    value: 0,
    label: '0',
  }];

  private relateRules: any = {
    videoId: [
      { required: true, message: '视频名称不能为空', trigger: 'blur' },
    ],
    videoTitle: [
      { required: true, message: '章节视频标题', trigger: 'blur' },
    ],
    sort: [
      { required: true, message: '请输入视频排序', trigger: 'blur' },
    ],
    userType: [
      { required: true, message: '请选择使用者', trigger: 'blur' },
    ],
  };

  private videoList: any = [];

  private teacherStu: number = 1;

  private teacher: number = 2;

  private addForm: any = this.videoForm;

  private videoSearchLoading: boolean = false

  mounted() {
    if (this.title.includes('修改')) this.form = Object.assign({}, this.oldForm);
    else this.form.chapterId = this.oldForm.stepPid;
    this.page.pageSize = 42;
    // const data = { pageSize: this.page.pageSize, pageNo: this.page.pageNo };
    // const data = { pageSize: '', pageNo: '' }
    // const title = '';
    // videoApi.getVideoList(data, title).then((res: any) => {
    //   this.videoList = res.content;
    // });
  }

  // submit(title: string) {
  //   this.loading = true;
  //   this.$refs.form.validate((valid: boolean) => {
  //     if (valid) {
  //       if (title.includes('修改')) {
  //         api.editVideo(this.form).then(() => {
  //           this.reset(true, true);
  //         /* eslint-disable no-return-assign */
  //         }).catch(() => (this.loading = false));
  //       } else {
  //         api.addVideo(this.form).then(() => {
  //           this.reset(true, true);
  //         /* eslint-disable no-return-assign */
  //         }).catch(() => (this.loading = false));
  //       }
  //     } else this.loading = false;
  //   });
  // }

  handleVideoName(v: string) {
    if (v.trim() === '') {
      this.videoList = [];
      return;
    }
    this.videoSearchLoading = true;
    if (v) {
      api.findVideoList(v.trim()).then((res: any) => {
        this.videoList = res;
        this.videoSearchLoading = false;
      });
    } else {
      this.videoList = [];
    }
  }

  // 重置表单
  reset(close: boolean = false, refrsh: boolean = false) {
    this.$refs.formRelate.resetFields();
    if (close) this.$emit('update:visible', false);
    if (refrsh) this.$emit('refrsh', this.form.stepPid);
    this.resetForm();
  }

  relateSubmit() {
    this.$refs.formRelate.validate((valid: boolean) => {
      if (valid) {
        if (this.title.includes('添加')) {
          api.relevanceVideo(this.addForm).then((res: any) => {
            this.$emit('refrsh', this.form.stepPid);
            this.$emit('update:visible', false);
          });
        } else {
          api.updataRelevance(this.addForm).then((res: any) => {
            this.$emit('refrsh', this.form.stepPid);
            this.$emit('update:visible', false);
          });
        }
      }
    });
  }

  resetRelate() {
    // console.log('重置');
    this.$refs.formRelate.resetFields();
  }
}
